import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { environment } from 'src/environments/environment';
import { AuthServiceFactory } from 'src/modules/b2c/auth-service-factory';
import { AppSetting } from 'src/modules/models/settings/casual-portal/app-setting';
import { ICart, Store } from 'src/modules/store';
import { Contact } from '../../models/client/contact';
import { BaseComponent } from '../base.component';
import { ILoadingStatus } from 'src/modules/store/loading';
import { AuthService } from 'src/modules/b2c/auth-service';

@Component({
  selector: 'opt-b2c-warning',
  templateUrl: './b2c-warning.component.html'
})
export class B2cWarningComponent extends BaseComponent implements OnInit {
  contactStatus: number;
  ciamContact: Contact;
  dbContact: Contact;
  isB2cEnabled: boolean = false;
  isInitialized = false;

  authService: AuthService;

  @Output() contactStatusChange = new EventEmitter<number>();// this will return error code if inactove or alredy email exists scenario

  constructor(private store: Store<any>) {
    super();
    var appSetting = environment.AppSetting as AppSetting;
    this.isB2cEnabled = AuthServiceFactory.isB2CEnable(appSetting)
    this.authService = AuthServiceFactory.createAuthService(appSetting)
  }

  ngOnInit() {


    /*     if (!this.isB2cEnabled) {
          this.contactStatusChange.emit(0);
        }
     */
    this.store.select('cart').pipe().subscribe((st: ICart) => {
      this.ciamContact = st.b2cContact;
      this.dbContact = st.contact;
    });

    this.store.select('loader').pipe().safeSubscribe(this, async (st: ILoadingStatus) => {

      if (st.ciamDataLoaded) {
        // if (this.ciamContact && this.ciamContact.ssoContactRef) 
        {
          if (!this.isInitialized) {
            this.isInitialized = true;
            this.populateContactStatusMessage(this.ciamContact, this.dbContact);
          }
        }
      }
    })



  }

  populateContactStatusMessage(
    ciamContact: Contact | undefined,
    dbContact: Contact | undefined
  ) {

    /*
    2: Optimo contact is inactive
    3: Contact is exists in optimo,
    */

    let isCiamLoggedin = ciamContact && ciamContact.ssoContactRef ? ciamContact.ssoContactRef !== '' : false;

    var _ssoRef = ciamContact ? (this.authService.getSSOContactRef(ciamContact) ?? "") : "";
    if (this.isB2cEnabled && isCiamLoggedin && dbContact && dbContact.id) {
      if (dbContact.active == false) {
        this.contactStatus = 2;
      } else if ((dbContact && dbContact.ssoContactRef ? dbContact.ssoContactRef : '') != (_ssoRef)) {
        this.contactStatus = 3;
      }
      /*   else {
         this.contactStatus = 0;
       } */

    }
    /*  else { //if (isCiamLoggedin && (!dbContact || !dbContact.id)) {
       this.contactStatus = 0;
     } */
    console.log('this.contactStatus: ' + this.contactStatus)
    if (this.contactStatus > 0)
      this.contactStatusChange.emit(this.contactStatus);


  }
}
